import React from 'react';
import { Form, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification } from 'antd';
import { getPermissions } from '../../modules/Api';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ReferralForm extends React.Component{

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({},
                fieldsValue
            ));
        })
    }
    render(){
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;

        return (
            <div style={{direction: 'rtl'}}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="عنوان"
                                colon={false}>
                                {getFieldDecorator("label", {
                                    initialValue: this.props.initialData.label ? this.props.initialData.label : '',
                                    rules: [{
                                        required: true, message:'لطفا عنوان را وارد کنید'
                                    }]
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="تعداد هدیه"
                                colon={false}>
                                {getFieldDecorator("amount", {
                                    initialValue: this.props.initialData.amount ? this.props.initialData.amount : '0',
                                    rules: [{
                                        required: true, message:'لطفا عدد وارد کنید',
                                        pattern: new RegExp(
                                            /^[0-9]+$/i
                                        )
                                    }]
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                            <Form.Item>
                                <div className="btn-container">
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={hasErrors(getFieldsError()) || this.props.submitted}
                                        >
                                        {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                                    </Button>
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
export default Form.create({ name: 'horizontal_login' })(ReferralForm);



// WEBPACK FOOTER //
// ./src/containers/Referral/form.js